import {IGlobalStore} from "modules/types";
import {createSelector} from "reselect";
import { memoize } from 'lodash';
import { EnumTriviaStatsContestType } from "modules/utils/enums";

export const getTriviaStats = (store: IGlobalStore) => store.trivia_stats;

export const getTriviaStatsContest = createSelector(
	[getTriviaStats],
	(state) => state.contest
);

export const getTriviaStatsContestByType = createSelector(
	[getTriviaStatsContest],
	(contest) => memoize((type: EnumTriviaStatsContestType) => {
		return contest[type];
	})
);
